import { Stack } from '@mui/material'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { roundingNumber } from 'components/shared/processes'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

export const FoodDistributeWidget = () => {
	const { statistics } = useWidgetStatistics()

	const distribute = statistics?.distribution
	const total = distribute?.total
	return (
		<Stack direction='column' gap='8px'>
			<TypographySecondary>Роздано корма</TypographySecondary>
			<Stack direction='row' gap='4px' alignItems='center'>
				{total || total === 0 ? (
					<TypographyPrimary16Bold>
						{roundingNumber(total, 0).toLocaleString()}
					</TypographyPrimary16Bold>
				) : (
					<TypographySecondary14>Нет данных</TypographySecondary14>
				)}
				<TypographyPrimary12>
					{total || total === 0 ? 'кг' : ''}
				</TypographyPrimary12>
			</Stack>
		</Stack>
	)
}
